/* import __COLOCATED_TEMPLATE__ from './csv-column-advanced.hbs'; */
/* RESPONSIBLE TEAM: team-email */
import Component from '@glimmer/component';
import { type ValidatedRow } from 'embercom/controllers/apps/app/settings/workspace/teammates/invite/csv-import-advanced';

interface Args {
  rows: ValidatedRow[];
  header: string;
}

export default class CsvColumnAdvanced extends Component<Args> {
  previewRowCount = 50;

  get rowsLeftCount() {
    return this.previewRowCount > this.args.rows.length
      ? 0
      : this.args.rows.length - this.previewRowCount;
  }

  get bodyRows() {
    return this.args.rows.slice(0, this.previewRowCount);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::Teammates::Invites::Edit::CsvColumnAdvanced': typeof CsvColumnAdvanced;
    'settings/teammates/invites/edit/csv-column-advanced': typeof CsvColumnAdvanced;
  }
}
